import { render, staticRenderFns } from "./Interact.vue?vue&type=template&id=6abf71b4&"
import script from "./Interact.vue?vue&type=script&lang=js&"
export * from "./Interact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports